//
//
//
//
//
//
//
//
import Result from "./Result";
import { mixinDevice } from '@/utils/mixin.js';
var directionType = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
export default {
  name: "Success",
  components: {
    Result: Result
  },
  mixins: [mixinDevice],
  data: function data() {
    return {
      title: '提交成功',
      description: '提交结果页用于反馈一系列操作任务的处理结果，\n',
      directionType: directionType
    };
  }
};